import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  USER_PERMISSIONS_LIST,
  USER_PERMISSIONS_NEW,
  USER_PERMISSIONS_EDIT,
  USER_PERMISSIONS_DELETE,
  USER_PERMISSIONS_TYPES_LIST,
} from "./actionTypes"

import {
  userPermissionsListSuccess,
  userPermissionsListError,
  userPermissionsNewSuccess,
  userPermissionsNewError,
  userPermissionsDeleteSuccess,
  userPermissionsDeleteError,
  userPermissionsTypesListSuccess,
  userPermissionsTypesListError,
} from "./actions"

import {
  apiGetUserPermissionsList,
  apiPostUserPermissionsNew,
  apiPatchUserPermissionsEdit,
  apiDeleteUserPermissionsDelete,
  apiGetUserPermissionsTypesList,
} from "../../../api/calls/userPermissions"

function* userPermissionsList({payload: data}) {
  try {
    const response = yield call(apiGetUserPermissionsList, data)
    yield put(userPermissionsListSuccess(response))
  } catch (error) {
    yield put(userPermissionsListError(error))
  }
}

function* userPermissionsNew({payload: data}) {
  try {
    const response = yield call(apiPostUserPermissionsNew, data)
    yield put(userPermissionsNewSuccess(response))
  } catch (error) {
    yield put(userPermissionsNewError(error))
  }
}

function* userPermissionsEdit({payload: data}) {
  try {
    const response = yield call(apiPatchUserPermissionsEdit, data)
    yield put(userPermissionsNewSuccess(response))
  } catch (error) {
    yield put(userPermissionsNewError(error))
  }
}

function* userPermissionsDelete({payload: data}) {
  try {
    const response = yield call(apiDeleteUserPermissionsDelete, data)
    yield put(userPermissionsDeleteSuccess(response))
  } catch (error) {
    yield put(userPermissionsDeleteError(error))
  }
}

function* userPermissionsTypesList({payload: data}) {
  try {
    const response = yield call(apiGetUserPermissionsTypesList, data)
    yield put(userPermissionsTypesListSuccess(response))
  } catch (error) {
    yield put(userPermissionsTypesListError(error))
  }
}

export function* watchUserPermissionsList() {
  yield takeEvery(USER_PERMISSIONS_LIST, userPermissionsList);
}

export function* watchUserPermissionsNew() {
  yield takeEvery(USER_PERMISSIONS_NEW, userPermissionsNew);
}

export function* watchUserPermissionsEdit() {
  yield takeEvery(USER_PERMISSIONS_EDIT, userPermissionsEdit);
}

export function* watchUserPermissionsDelete() {
  yield takeEvery(USER_PERMISSIONS_DELETE, userPermissionsDelete);
}

export function* watchUserPermissionsTypesList() {
  yield takeEvery(USER_PERMISSIONS_TYPES_LIST, userPermissionsTypesList);
}

function* userPermissionsSaga() {
  yield all([
    fork(watchUserPermissionsList),
    fork(watchUserPermissionsNew),
    fork(watchUserPermissionsEdit),
    fork(watchUserPermissionsDelete),
    fork(watchUserPermissionsTypesList),
  ]);
}

export default userPermissionsSaga
